import { OpenEditSVG } from "./OpenEditSVG";
export default OpenEditSVG;
